import { useNavigate, useParams } from "react-router";

/**
 * Navega dentro da loja atual, mantendo o prefixo da URL
 * (/:namespace ou /:namespace/:orderLocation/:mesaId).
 *
 * Sempre com replace: o app inteiro conta com isso (voltar do produto
 * remonta a lista, e o fluxo checkout -> status não deixa a sacola no
 * histórico).
 *
 * `state` vai no location.state do destino (ex. { upsell: true } para a tela
 * de produto saber que veio do "Peça também").
 */
export default function useGoTo() {
  const navigate = useNavigate();
  const { namespace, orderLocation, mesaId } = useParams();
  const prefix =
    orderLocation && mesaId
      ? `/${namespace}/${orderLocation}/${mesaId}`
      : `/${namespace}`;

  return (endpoint = "/", state) =>
    navigate(`${prefix}${endpoint}`, { replace: true, state });
}
